const { createStatusMachine } = require('./statusMachine');

// A review starts hidden and flips to visible once both the host's and the
// guest's reviews for a booking exist (the "blind reveal" in functions/index.js).
const ReviewVisibility = Object.freeze({
  HIDDEN: 'hidden',
  VISIBLE: 'visible',
});

const reviewVisibilityMachine = createStatusMachine({
  entityName: 'review',
  states: Object.values(ReviewVisibility),
  initial: ReviewVisibility.HIDDEN,
  transitions: {
    [ReviewVisibility.HIDDEN]: [ReviewVisibility.VISIBLE],
    [ReviewVisibility.VISIBLE]: [],
  },
});

const toIsVisible = (visibility) => visibility === ReviewVisibility.VISIBLE;
const fromIsVisible = (isVisible) => (isVisible ? ReviewVisibility.VISIBLE : ReviewVisibility.HIDDEN);

module.exports = { ReviewVisibility, reviewVisibilityMachine, toIsVisible, fromIsVisible };
